import React, { useState } from 'react';
import { Clock, CheckCircle, DotsThreeVertical, Copy, ArrowClockwise, Trash, Eye } from '@phosphor-icons/react';
import { ActionMenu } from '../ui/ActionMenu';
import { cn } from '../../lib/utils';
export interface ReviewRequest {
  id: string;
  landlordName: string;
  landlordEmail: string;
  token: string;
  sentAt: string;
  status: 'sent' | 'completed' | 'expired';
}
interface PendingReviewRequestProps {
  request: ReviewRequest;
  onResend: (id: string) => void;
  onCancel: (id: string) => void;
  onTestLink?: (token: string) => void;
}
export function PendingReviewRequest({
  request,
  onResend,
  onCancel,
  onTestLink
}: PendingReviewRequestProps) {
  const [copied, setCopied] = useState(false);
  const reviewUrl = typeof window !== 'undefined' ? `${window.location.origin}/r/${request.token}` : `/r/${request.token}`;
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(reviewUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  };
  return <div className="flex items-center justify-between gap-3 px-4 py-3 bg-dark-1 border border-dark-3 rounded-xl" data-id="element-712">
      <div className="flex items-center gap-3 min-w-0" data-id="element-713">
        <div className="shrink-0 w-8 h-8 rounded-full bg-dark-3 flex items-center justify-center text-xs font-medium text-light-2" data-id="element-714">
          {request.landlordName[0]}
        </div>
        <div className="min-w-0" data-id="element-715">
          <div className="text-sm font-medium text-light-1 truncate" data-id="element-716">
            {request.landlordName}
          </div>
          <div className="text-xs text-light-4 truncate" data-id="element-717">
            Trimisă pe {request.sentAt}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2 shrink-0" data-id="element-718">
        {request.status === 'sent' && <div className="hidden sm:inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-dark-3 text-xs font-medium text-light-3" data-id="element-719">
            <Clock size={12} weight="regular" data-id="element-720" />
            În așteptare
          </div>}
        {request.status === 'completed' && <div className="hidden sm:inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-lime-5 text-xs font-medium text-lime-1 border border-lime-4" data-id="element-721">
            <CheckCircle size={12} weight="fill" data-id="element-722" />
            Completată
          </div>}

        <ActionMenu triggerAriaLabel="Acțiuni invitație" items={[{
        label: copied ? 'Link copiat' : 'Copiază link',
        icon: <Copy size={18} weight="regular" data-id="element-724" />,
        onClick: handleCopy,
        closeOnClick: false
      }, ...(onTestLink ? [{
        label: 'Testează linkul',
        icon: <Eye size={18} weight="regular" data-id="element-725" />,
        onClick: () => onTestLink(request.token)
      }] : []), {
        label: 'Trimite din nou',
        icon: <ArrowClockwise size={18} weight="regular" data-id="element-726" />,
        onClick: () => onResend(request.id)
      }, {
        label: 'Anulează',
        icon: <Trash size={18} weight="regular" data-id="element-727" />,
        onClick: () => onCancel(request.id),
        destructive: true
      }]} data-id="element-723" />
      </div>
    </div>;
}